export const KeyBooleanHash = Symbol('KeyBooleanHash');
export const KeyValueHash = Symbol('KeyValueHash');
export const KeyValuePair = Symbol('KeyValuePair');
export const WhereManyInput = Symbol('WhereManyInput');

export const ContentShareWhereManyInput = {
  AND: true,
  OR: true,
  NOT: true,
  id: {
    label: 'ID is',
    type: String,
  },
  id_in: {
    label: 'ID in',
    type: Array,
    item: String,
  },
  atsID: {
    label: 'ATS ID is',
    type: String,
  },
  atsID_in: {
    label: 'ATS ID in',
    type: Array,
    item: String,
  },
  domain: {
    label: 'Domain is',
    type: String,
  },
  url: {
    label: 'URL is',
    type: String,
  },
  status: {
    label: 'Status is',
    type: String,
    default: 'ACTIVE',
    enum: [
      { text: 'Active', value: 'ACTIVE' },
      { text: 'Inactive', value: 'INACTIVE' },
      { text: 'Deleted', value: 'DELETED' },
    ],
  },
};

export const JobWhereManyInput = {
  AND: true,
  OR: true,
  NOT: true,
  id: {
    label: 'ID is',
    type: String,
  },
  id_in: {
    label: 'ID in',
    type: Array,
    item: String,
  },
  atsID: {
    label: 'ATS ID is',
    type: String,
  },
  atsID_in: {
    label: 'ATS ID in',
    type: Array,
    item: String,
  },
  title: {
    label: 'Title contains',
    type: String,
  },
  isDevelopment: {
    label: 'Is Development',
    type: Boolean,
    default: false,
  },
  isInternal: {
    label: 'Is Internal',
    type: Boolean,
    default: false,
  },
  isPinned: {
    label: 'Is Pinned',
    type: Boolean,
    default: false,
  },
  isRemote: {
    label: 'Is Remote',
    type: Boolean,
    default: false,
  },
  atsData: {
    label: 'ATS Data contains',
    type: KeyValueHash,
  },
  customFields: {
    label: 'Custom Fields contain',
    type: KeyValueHash,
  },
  status: {
    label: 'Status is',
    type: String,
    default: 'ACTIVE',
    enum: [
      { text: 'Active', value: 'ACTIVE' },
      { text: 'Inactive', value: 'INACTIVE' },
      { text: 'Deleted', value: 'DELETED' },
    ],
  },
};

export const SegmentWhereManyInput = {
  AND: true,
  OR: true,
  NOT: true,
  id: {
    label: 'ID is',
    type: String,
  },
  id_in: {
    label: 'ID in',
    type: Array,
    item: String,
  },
  departments: {
    label: 'Has Departments',
    type: Boolean,
    default: true,
  },
  users: {
    label: 'Has Users',
    type: Boolean,
    default: true,
  },
  jobs: {
    label: 'Has Jobs',
    type: Boolean,
    default: true,
  },
  contentShares: {
    label: 'Has Content Shares',
    type: Boolean,
    default: true,
  },
  rewards: {
    label: 'Has Rewards',
    type: Boolean,
    default: true,
  },
  status: {
    label: 'Status is',
    type: String,
    default: 'ACTIVE',
    enum: [
      { text: 'Active', value: 'ACTIVE' },
      { text: 'Inactive', value: 'INACTIVE' },
      { text: 'Deleted', value: 'DELETED' },
    ],
  },
};

export const ScimUserWhereManyInput = {
  AND: true,
  OR: true,
  NOT: true,
  id: {
    label: 'ID is',
    type: String,
  },
  id_in: {
    label: 'ID in',
    type: Array,
    item: String,
  },
  externalID: {
    label: 'External ID is',
    type: String,
  },
  emailAddress: {
    label: 'Email Address is',
    type: String,
  },
  title: {
    label: 'Title is',
    type: String,
  },
  timezone: {
    label: 'Timezone is',
    type: String,
  },
  organization: {
    label: 'Organization is',
    type: String,
  },
  department: {
    label: 'Department is',
    type: String,
  },
  division: {
    label: 'Division is',
    type: String,
  },
  countryCode: {
    label: 'Country Code is',
    type: String,
  },
  countryCode_in: {
    label: 'Country Code in',
    type: Array,
    item: String,
  },
  location: {
    label: 'Location is',
    type: String,
  },
  active: {
    label: 'Active',
    type: Boolean,
    default: true,
  },
};

export const UserWhereManyInput = {
  AND: true,
  OR: true,
  NOT: true,
  id: {
    label: 'ID is',
    type: String,
  },
  id_in: {
    label: 'ID in',
    type: Array,
    item: String,
  },
  name: {
    label: 'Name is',
    type: String,
  },
  emailAddress: {
    label: 'Email Address is',
    type: String,
  },
  role: {
    label: 'Role is',
    type: String,
    default: 'EMPLOYEE',
    enum: [
      { text: 'Employee', value: 'EMPLOYEE' },
      { text: 'Recruiter', value: 'RECRUITER' },
      { text: 'Recruiter Admin', value: 'RECRUITER_ADMIN' },
    ],
  },
  company: {
    label: 'Company is',
    type: String,
  },
  title: {
    label: 'Title is',
    type: String,
  },
  share: {
    label: 'Share code is',
    type: String,
  },
  share_in: {
    label: 'Share code in',
    type: Array,
    item: String,
  },
  // preferences: {
  //   label: 'Preferences are',
  //   type: KeyBooleanHash,
  //   options: [
  //     { key: 'receiveWeeklyEmails', description: 'Receive Weekly Emails' },
  //     { key: 'receiveReengagementEmails', description: 'Receive Reengagement Emails' },
  //     { key: 'visibleInLeaderboards', description: 'Participate in leaderboards' },
  //   ],
  // },
  customField: {
    label: 'Custom field is',
    type: KeyValuePair,
  },
  customFields: {
    label: 'Custom fields has',
    type: Array,
    item: KeyValuePair,
  },
  scim: {
    label: 'SCIM where',
    type: WhereManyInput,
    options: ScimUserWhereManyInput,
    default: { active: true },
  },
  status: {
    label: 'Status is',
    type: String,
    default: 'ACTIVE',
    enum: [
      { text: 'Active', value: 'ACTIVE' },
      { text: 'Inactive', value: 'INACTIVE' },
      { text: 'Deleted', value: 'DELETED' },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/models/where.js